export const CAUHINHTAILIEU_SET_LIST_DATA = 'CAUHINHTAILIEU_SET_LIST_DATA';
export const CAUHINHTAILIEU_SET_LIST_META = 'CAUHINHTAILIEU_SET_LIST_META';
export const CAUHINHTAILIEU_TITLE = 'trường dữ liệu';